(function () {
    'use strict';

    angular
        .module('app')
        .component('temaListAdmin', {
            templateUrl: 'app/components/auladigital/admin/tema/tema-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl'
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, Tema, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = Tema;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {
            key: null,
            padreId: $stateParams.materiaid
        };
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (Tema) {
                            return Tema.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'aulaDigital.tema.admin.delete.title',
                                body: 'aulaDigital.tema.admin.delete.confirm',
                                property: 'titulo'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();
